import { Injectable } from '@angular/core';
import { IAnalycticsNativeService } from './ianalyctics-native';

declare const trackState;
declare const trackAction;

declare global {
    interface Window {
        webkit: any;
        JSBridge: any;
    }
}

@Injectable({ providedIn: 'root' })
export class AnalycticsNativeService implements IAnalycticsNativeService {


    analyticsTrackStateCommunicator(it_pagename?: string, it_complementary?: object) {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.trackState) {
            this.comunicationIos(it_pagename, it_complementary);
        } else {
            this.comunicationAndroid(it_pagename, it_complementary);
        }
    }

    analyticsTrackActionCommunicator(it_eventcategory?: string, it_complementary?: object) {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.trackAction) {
            this.comunicationTrackActionIos(it_eventcategory, it_complementary);
        } else {
            this.comunicationTrackActionAndroid(it_eventcategory, it_complementary);
        }
    }

    private comunicationIos(it_pagename?: string, it_complementary?: object) {
        window.webkit.messageHandlers.trackState.postMessage({
            it_pagename,
            it_complementary
        });
    }

    private comunicationAndroid(it_pagename?: string, it_complementary?: object) {
        try {
            trackState.postMessage(JSON.stringify({it_pagename}), JSON.stringify({it_complementary}));
        } catch (error) {
        }
    }

    private comunicationTrackActionIos(it_eventcategory?: string, it_complementary?: object) {
        window.webkit.messageHandlers.trackAction.postMessage({
            it_eventcategory,
            it_complementary
        });
    }

    private comunicationTrackActionAndroid(it_eventcategory?: string, it_complementary?: any) {
        const data = {
            'it_pagename': it_complementary?.it_pagename,
            'complementary': [
                {key: 'it_category', value: it_eventcategory},
                {key: 'it_eventAction', value: it_complementary?.it_eventaction},
                {key: 'it_eventLabel', value: it_complementary?.it_eventlabel}
            ]
        };
        try {
            trackAction.postMessage(JSON.stringify({data}));
        } catch (error) {
        }
    }
}

